import React from 'react';
import './TermsOfUse.css';

const PrivacyPolicy = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Política de Privacidade</h1>
        <div className="terms-content">
          <p className="terms-intro">
            Esta Política de Privacidade descreve como tratamos dados pessoais coletados por meio deste site,
            em conformidade com a legislação aplicável, incluindo a LGPD, no âmbito de
            <strong> Navarro & Vieira Advogados</strong>.
          </p>

          <section className="terms-section">
            <h2>1. Dados coletados</h2>
            <ul>
              <li>Dados fornecidos voluntariamente em formulários (ex.: nome, e-mail, mensagem).</li>
              <li>Dados técnicos de navegação para segurança e melhoria do serviço.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>2. Finalidade do tratamento</h2>
            <ul>
              <li>Responder solicitações enviadas pelo usuário.</li>
              <li>Viabilizar funcionalidades da área de cliente.</li>
              <li>Manter a segurança e integridade da plataforma.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>3. Compartilhamento</h2>
            <p>
              Não comercializamos dados pessoais. O compartilhamento pode ocorrer apenas quando necessário para
              cumprimento de obrigação legal, ordem judicial ou operação técnica do serviço.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Armazenamento e segurança</h2>
            <p>
              Adotamos medidas técnicas e administrativas para reduzir riscos de acesso não autorizado, alteração,
              perda ou divulgação indevida de dados.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Direitos do titular</h2>
            <p>
              O titular pode solicitar acesso, correção e demais direitos previstos em lei por meio dos canais de contato do escritório.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Contato</h2>
            <p>
              Para questões sobre privacidade, utilize a página de contato do site.
            </p>
            <p>
              Responsáveis: Marcos Antônio dos Santos Navarro (OAB/PR 101.424) e
              Mateus Bortotto Vieira (OAB/PR 101.759).
            </p>
          </section>

          <div className="terms-footer">
            <p><strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-BR')}</p>
            <p>© {new Date().getFullYear()} Navarro & Vieira Advogados. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
